import { createPersistedOptimisticOverlay } from '@/util/persistedOptimisticOverlay'
import type { ArtistFollowsContext } from '@amzn/amp-playback'

// Leaf (see persistedOptimisticOverlay) so the boot-eager reapply doesn't drag
// artistFollowService's mutation + toggle machinery onto the entry chunk.
export const artistFollowOverlay = createPersistedOptimisticOverlay<boolean>({
    persistenceKey: 'overlay:artistFollow',
    validateValue: (v): v is boolean => typeof v === 'boolean',
    buildEntity: (artistId, followed): ArtistFollowsContext => ({
        __typename: 'Artist',
        id: artistId,
        followsContext: { isFollowed: followed },
    }),
})

/** Re-arm the normalized cache from persisted artist follows on boot. */
export const reapplyPersistedArtistFollows = artistFollowOverlay.reapplyPersisted
